import { useState } from "react";
import Header from "../../comps/Header";
import Footer from "../../comps/Footer";
import { Link } from "react-router-dom";
import { user_forgot_password } from "../../api/Auth"
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

const Forgot_Password_Email = () => {
    const [formData, setFormData] = useState({ email: "", });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    // Handle input change
    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === "checkbox" ? checked : value
        });
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");

        const formDataToSend = new FormData();
        formDataToSend.append("email", formData.email);
        try {
            const response = await user_forgot_password(formDataToSend); // Use global function

            if (response?.data?.status === 200 || response?.data?.status === "200") {
                toast.success("Password reset email has been sent.!")
            } else {
                setError("Unable to send reset link. Please try again.");
            }
        } catch (error) {
            setError("An unexpected error occurred. Please try again.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <div>
            <Header />
            {/* <-------- ToastContainer ------------> */}
            <ToastContainer style={{ marginTop: "120px" }} />
            <section className="relative overflow-hidden py-10 md:py-24">
                <div className="absolute inset-0 -z-10 bg-[#111315]"></div>
                <div className="absolute inset-0 -z-10 theme-hero-bg"></div>
                <div className="absolute inset-0 -z-10 theme-grid-overlay" />
                <div className="mx-auto max-w-7xl px-6 lg:px-8 relative">
                    <div className="flex flex-col items-center justify-center">
                        <div className="w-full rounded-xl border border-amber-500/20 bg-[#252b33]/95 shadow-2xl backdrop-blur-xl sm:max-w-md">
                            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
                                <p className="font-bold leading-tight tracking-tight text-stone-200">
                                    Lost your password? Please enter your username or email address
                                </p>

                                {error && (
                                    <div className="text-red-400 text-sm font-medium">
                                        {error}
                                    </div>
                                )}

                                <form className="space-y-4" onSubmit={handleSubmit}>
                                    {/* Email Field */}
                                    <div>
                                        <label className="block mb-2 text-sm font-medium text-stone-200">
                                            Your Email ID
                                        </label>
                                        <input
                                            type="email"
                                            name="email"
                                            className="theme-input"
                                            placeholder="name@company.com"
                                            required
                                            value={formData.email}
                                            onChange={handleChange}
                                        />
                                    </div>

                                    {/* Submit Button */}
                                    <button type="submit" className="theme-btn-primary w-full px-5 py-2.5 text-center text-sm" disabled={loading}>
                                        {loading ? "Reseting Password..." : "Reset Password"}
                                    </button>
                                    {/* Signup Link */}
                                    <p className="text-sm text-center text-stone-300">
                                        Already have an account?{" "}
                                        <Link to="/login" className="font-medium text-amber-400 hover:underline">
                                            Sign in
                                        </Link>
                                    </p>
                                    {/* <div className="inline-flex items-center justify-center w-full">
                                        <hr className="w-64 h-1  bg-gray-300 border-0 rounded-sm dark:bg-gray-700" />
                                        <div className="absolute px-4 -translate-x-1/2 text-gray-300 font-semibold left-1/2 bg-white">
                                            or
                                        </div>
                                    </div> */}


                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </div>
    )
}

export default Forgot_Password_Email
